import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';


document.addEventListener('DOMContentLoaded', _ => {
    document.querySelectorAll('.stepped-carousel').forEach(carousel => {
        const slider = new Swiper(carousel, {
            modules: [Navigation, Scrollbar],
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            initialSlide: 0,
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 26,
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
        });
    });
});
